import {Component, Input} from "@angular/core";
import {AssetStatus} from "../../asset/asset.types";

@Component({
  selector: "asset-status-card",
  templateUrl: "./asset-status-card.template.pug",
})
export class AssetStatusCardComponent {
  statuses = {
    0: "Pending",
    1: "Processing",
    2: "Acknowledged",
    3: "Production",
    4: "Shipped",
    5: "Delivered",
  };

  @Input() asset: AssetStatus;
  get statusesLength() { return Object.keys(this.statuses).length - 1; }
  get coloredStatusesLength() { return new Array(this.asset.status || 0); }
  get uncoloredStatusesLength() { return new Array(this.statusesLength - (+this.asset.status || 0)); }
}
